import pxToRem from "../../Theme/functions/pxToRem";
import borders from "../../Theme/base/borders";
import colors from "../../Theme/base/colors";

const { background, text, border, error } = colors;
const { borderRadius } = borders;

export default {
  styleOverrides: {
    root: {
      fontSize: pxToRem(14),
      borderRadius: borderRadius.md,
      backgroundColor: background.default,
      borderColor: border.main,
      // height: "40px",
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: border.brand,
      },
      "&.Mui-disabled": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: border.main,
        },
      },
      "&.Mui-focused": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderWidth: "1px",
          // borderColor: info.main,
          borderColor: border.brand,
        },
      },
      "& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
        {
          display: "none",
        },

      "&.Mui-error": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: error.main,
          borderWidth: "1px",
        },
      },
    },

    medium: {
      height: "40px",
    },

    notchedOutline: {
      borderColor: border.main,
    },

    input: {
      color: text.main,
      padding: pxToRem(14),
      borderColor: border.dark,
      // backgroundColor: background.default,
    },

    inputSizeSmall: {
      fontSize: pxToRem(12),
      padding: pxToRem(10),
    },

    multiline: {
      color: border.disabled,
      padding: 0,
    },
  },
};
